export default function Footer() {
	return (
		<div className='footer'>
			<h1>Logo</h1>
			<p>text</p>
		</div>
	);
}
